// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataObjectItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import AppGlobal from 'Izenda.AppGlobal';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import CustomCheckbox from 'share/components/controls/Izenda.CustomCheckbox';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { isEmpty } from 'lodash/fp';

const DataObjectItem = props => {
  const {
    node,
    store,
    dataSource,
    toggleIcon,
    collapseToggle,
    useCheckBox,
    filterText,
    handleCheck
  } = props;

  const objectItemClass = classnames({
    normal: !useCheckBox,
    checkbox: useCheckBox
  });

  const tooltip = `${dataSource.connectionName}.${dataSource.querySourceCategoryName}.${dataSource.originalName}`;

  const textDisplay = AppGlobal.advancedSettings.other.showSchemaNameValue
    ? `${dataSource.querySourceCategoryName}.${dataSource.name}`
    : dataSource.name;

  return (
    <div className={objectItemClass}>
      <OverflowText
        className="selectable"
        text={textDisplay}
        tooltip={tooltip}
        onClick={collapseToggle}
      >
        <i className={store.dataTree.getIcon(dataSource.type)} />
        <TextHighLight
          text={textDisplay}
          tooltip={tooltip}
          highlight={filterText}
        />
      </OverflowText>

      <span className="pull-right">
        {toggleIcon}
        {useCheckBox &&
          <CustomCheckbox
            type="checkbox"
            checked={dataSource.selected}
            onChange={handleSelect}
          />
        }
      </span>

    </div>
  );

  function handleSelect(e) {
    handleCheck(dataSource, e.target.checked, node);
  }
};

DataObjectItem.displayName = 'DataObjectItem';

export default observer(DataObjectItem);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.DataObjectItem.js